/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLayoutAlignTopFilled = createReactComponent("filled", "layout-align-top-filled", "IconLayoutAlignTopFilled", [["path", { "d": "M20 3a1 1 0 0 1 0 2h-16a1 1 0 1 1 0 -2z", "key": "svg-0" }], ["path", { "d": "M13 7a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z", "key": "svg-1" }]]);

export { IconLayoutAlignTopFilled as default };
//# sourceMappingURL=IconLayoutAlignTopFilled.mjs.map
